import http from '@/utils/ajax'
import clone from 'clone'
import { extractMenu, extractMessages } from '@/utils/extract'
import { PACKAGE_INIT_LOADING, PACKAGE_INIT_SUCCESS, PACKAGE_INIT_FAIL, SCHEME_INIT_LOADING, SCHEME_INIT_SUCCESS, SCHEME_INIT_FAIL, POLTYPESCHEME_INIT_LOADING, POLTYPESCHEME_INIT_SUCCESS, POLTYPESCHEME_INIT_FAIL, TARIFFBEN_INIT_LOADING,
  TARIFFBEN_INIT_SUCCESS, TARIFFBEN_INIT_FAIL, TARIFFBEN_COMMIT_KEY, PACKAGEPLAN_INIT_LOADING, PACKAGEPLAN_INIT_SUCCESS, PACKAGEPLAN_INIT_FAIL, PACKAGEPLAN_COMMIT_KEY, PKGSTDRISKTXT_INIT_LOADING, PKGSTDRISKTXT_INIT_SUCCESS, PKGSTDRISKTXT_INIT_FAIL,
  PKGSTDRISKTXT_COMMIT_KEY, PKGSTDITEMTXT_INIT_LOADING, PKGSTDITEMTXT_INIT_SUCCESS, PKGSTDITEMTXT_INIT_FAIL, PKGSTDITEMTXT_COMMIT_KEY, PKGSTDSUBITEMTXT_INIT_LOADING, PKGSTDSUBITEMTXT_INIT_SUCCESS, PKGSTDSUBITEMTXT_INIT_FAIL, PKGSTDSUBITEMTXT_COMMIT_KEY, TARIFFFACT_INIT_LOADING, TARIFFFACT_INIT_SUCCESS, TARIFFFACT_INIT_FAIL, TARIFFFACT_COMMIT_KEY, TARIFFRATE_INIT_LOADING, TARIFFRATE_INIT_SUCCESS, TARIFFRATE_INIT_FAIL,
  TARIFFRATE_COMMIT_KEY, PACKAGERISK_COMMIT_KEY, PACKAGERISKITEM_COMMIT_KEY, SCHEMECLAUSE_INIT_LOADING, SCHEMECLAUSE_INIT_SUCCESS, SCHEMECLAUSE_INIT_FAIL, SCHEMECLAUSE_COMMIT_KEY, PACKAGERISKSUBITEM_COMMIT_KEY, ARB_COMMIT_KEY, IAB_COMMIT_KEY } from '@/store/types'
export const initialState = {
  init: 0,
  initErr: [],
  menu: {},
  scheme: {
    init: 0,
    initErr: [],
    menu: {}
  },
  polTypeScheme: {
    init: 0,
    initErr: [],
    menu: {}
  },
  tariffBen: {
    init: 0,
    initErr: [],
    menu: {},
    tariffBenId: {
      scheme: null,
      planNo: null,
      tariff: null,
      busCls: null,
      benefit: null,
      effDate: null
    }
  },
  pkgPlan: {
    init: 0,
    initErr: [],
    menu: {},
    pkgPlanId: {
      scheme: null,
      schemeDesc: null,
      seqNo: null,
      planNo: null,
      planDesc: null,
      effDate: null,
      // childDiscPct: null,
      noAdultChildDisc: null,
      polType: null,
      polTypeDesc: null,
      maxBenNo: null
    }
  },
  pkgStdRiskTxt: {
    init: 0,
    initErr: [],
    menu: {},
    pkgStdRiskTxtId: {
      scheme: null,
      riskNo: null,
      stdRiskTxtRef: null,
      busCls: null
    }
  },
  pkgStdItemTxt: {
    init: 0,
    initErr: [],
    menu: {},
    pkgStdItemTxtId: {
      scheme: null,
      riskNo: null,
      stdRiskTxtRef: null,
      stdRiskItemTxt: null,
      tranMode: null
    }
  },
  pkgStdSubItemTxt: {
    init: 0,
    initErr: [],
    menu: {},
    pkgStdSubItemTxtId: {
      scheme: null,
      riskNo: null,
      itemNo: null,
      subItemNo: null,
      subItemDesc: null
    }
  },
  tariffFact: {
    init: 0,
    initErr: [],
    menu: {},
    tariffFactId: {
      scheme: null,
      planNo: null,
      tariff: null,
      busCls: null,
      benefit: null,
      seqNo: null,
      effDate: null,
      fact1: null,
      fact2: null,
      fact3: null,
      fact4: null,
      fact5: null,
      fact6: null,
      tariffDesc: null,
      busClsDesc: null,
      benefitDesc: null
    }
  },
  tariffRate: {
    init: 0,
    initErr: [],
    menu: {},
    tariffRateId: {
      scheme: null,
      planNo: null,
      tariff: null,
      busCls: null,
      benefit: null,
      seqNo: null,
      effDate: null,
      fact1: null,
      fact2: null,
      fact3: null,
      fact4: null,
      fact5: null,
      fact6: null,
      tranMode: null
    }
  },
  pkgRisk: {
    init: 0,
    initErr: [],
    menu: {},
    pkgRiskId: {
      tranMode: undefined,
      scheme: undefined,
      planNo: undefined,
      riskNo: undefined,
      defBusCls: undefined,
      defTariff: undefined,
      defStdRiskTxtRef: undefined,
      perMaxItemNo: undefined,
      perMaxBeneNo: undefined,
      defClse1: undefined,
      defClse2: undefined,
      defClse3: undefined,
      defClse4: undefined,
      defClse5: undefined,
      allowClmBefCvr: false,
      schemeDesc: undefined,
      polTypeDesc: undefined
    }
  },
  pkgRiskItem: {
    init: 0,
    initErr: [],
    menu: {},
    pkgRiskItemId: {
      tranMode: undefined,
      scheme: undefined,
      planNo: undefined,
      riskNo: undefined,
      itemNo: undefined,
      defStdItemTxtRef: undefined,
      defUOM: undefined,
      uomAmt: 0,
      uomUN: undefined,
      defBenefit: undefined,
      minSI: 0,
      maxSI: 0,
      incSI: 0,
      protSI: true,
      protPrem: true,
      permitDel: false,
      mandOnPlan: true,
      defClse1: undefined,
      defClse2: undefined,
      defClse3: undefined,
      applyIndex: false,
      indexYr: 0,
      indexPct: 0,
      indexOn: undefined
    }
  },
  pkgRiskSubItem: {
    init: 0,
    initErr: [],
    menu: {},
    pkgRiskSubItemId: {
      tranMode: undefined,
      scheme: undefined,
      planNo: undefined,
      riskNo: undefined,
      itemNo: undefined,
      subItemNo: undefined
    }
  },
  schemeClause: {
    init: 0,
    initErr: [],
    menu: {},
    schemeClauseId: {
      scheme: null,
      clseNo: null
    }
  },
  arb: {
    init: 0,
    initErr: [],
    menu: {},
    arbId: {
      tranMode: undefined,
      scheme: undefined,
      planNo: undefined,
      renYr: undefined,
      effDate: undefined,
      arbCalcMeth: false,
      arbValRate: 0,
      arbGrsNet: true,
      totInstal: 0,
      gstApp: true
    }
  },
  iab: {
    init: 0,
    initErr: [],
    menu: {},
    iabId: {
      tranMode: undefined,
      scheme: undefined,
      planNo: undefined,
      adultInsd: true,
      insdAge: 0,
      expiryDate: undefined,
      nxtPlanNo: undefined
    }
  }
}

const getters = {

}

const mutations = {
  [PACKAGE_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [PACKAGE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data.menu
    state.initErr = []
  },
  [PACKAGE_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [SCHEME_INIT_LOADING](state) {
    state.scheme.init = 0
    state.scheme.menu = {}
    state.scheme.initErr = []
  },
  [SCHEME_INIT_SUCCESS](state, data) {
    state.scheme.init = 1
    state.scheme.menu = data.menu
    state.scheme.initErr = []
  },
  [SCHEME_INIT_FAIL](state, err) {
    state.scheme.init = 2
    state.scheme.menu = {}
    state.scheme.initErr = err
  },
  [POLTYPESCHEME_INIT_LOADING](state) {
    state.polTypeScheme.init = 0
    state.polTypeScheme.menu = {}
    state.polTypeScheme.initErr = []
  },
  [POLTYPESCHEME_INIT_SUCCESS](state, data) {
    state.polTypeScheme.init = 1
    state.polTypeScheme.menu = data.menu
    state.polTypeScheme.initErr = []
  },
  [POLTYPESCHEME_INIT_FAIL](state, err) {
    state.polTypeScheme.init = 2
    state.polTypeScheme.menu = {}
    state.polTypeScheme.initErr = err
  },
  [TARIFFBEN_INIT_LOADING](state) {
    state.tariffBen.init = 0
    state.tariffBen.menu = {}
    state.tariffBen.initErr = []
  },
  [TARIFFBEN_INIT_SUCCESS](state, data) {
    state.tariffBen.init = 1
    state.tariffBen.menu = data.menu
    state.tariffBen.initErr = []
  },
  [TARIFFBEN_INIT_FAIL](state, err) {
    state.tariffBen.init = 2
    state.tariffBen.menu = {}
    state.tariffBen.initErr = err
  },
  [TARIFFBEN_COMMIT_KEY](state, data) {
    state.tariffBen.tariffBenId.scheme = data.scheme
    state.tariffBen.tariffBenId.planNo = data.planNo
    state.tariffBen.tariffBenId.tariff = data.tariff
    state.tariffBen.tariffBenId.busCls = data.busCls
    state.tariffBen.tariffBenId.benefit = data.benefit
    state.tariffBen.tariffBenId.effDate = data.effDate
    state.tariffBen.tariffBenId.tranMode = data.tranMode
  },
  [PACKAGEPLAN_INIT_LOADING](state) {
    state.pkgPlan.init = 0
    state.pkgPlan.menu = {}
    state.pkgPlan.initErr = []
  },
  [PACKAGEPLAN_INIT_SUCCESS](state, data) {
    state.pkgPlan.init = 1
    state.pkgPlan.menu = data.menu
    state.pkgPlan.initErr = []
  },
  [PACKAGEPLAN_INIT_FAIL](state, err) {
    state.pkgPlan.init = 2
    state.pkgPlan.menu = {}
    state.pkgPlan.initErr = err
  },
  [PACKAGEPLAN_COMMIT_KEY](state, data) {
    state.pkgPlan.pkgPlanId.scheme = data.scheme
    state.pkgPlan.pkgPlanId.schemeDesc = data.schemeDesc
    state.pkgPlan.pkgPlanId.seqNo = data.seqNo
    state.pkgPlan.pkgPlanId.planNo = data.planNo
    state.pkgPlan.pkgPlanId.planDesc = data.planDesc
    state.pkgPlan.pkgPlanId.effDate = data.effDate
    // state.pkgPlan.pkgPlanId.childDiscPct = data.childDiscPct
    state.pkgPlan.pkgPlanId.noAdultChildDisc = data.noAdultChildDisc
    state.pkgPlan.pkgPlanId.polType = data.polType
    state.pkgPlan.pkgPlanId.polTypeDesc = data.polTypeDesc
    state.pkgPlan.pkgPlanId.maxBenNo = data.maxBenNo
    state.pkgPlan.pkgPlanId.tranMode = data.tranMode
  },
  [PKGSTDRISKTXT_INIT_LOADING](state) {
    state.pkgStdRiskTxt.init = 0
    state.pkgStdRiskTxt.menu = {}
    state.pkgStdRiskTxt.initErr = []
  },
  [PKGSTDRISKTXT_INIT_SUCCESS](state, data) {
    state.pkgStdRiskTxt.init = 1
    state.pkgStdRiskTxt.menu = data.menu
    state.pkgStdRiskTxt.initErr = []
  },
  [PKGSTDRISKTXT_INIT_FAIL](state, err) {
    state.pkgStdRiskTxt.init = 2
    state.pkgStdRiskTxt.menu = {}
    state.pkgStdRiskTxt.initErr = err
  },
  [PKGSTDRISKTXT_COMMIT_KEY](state, data) {
    state.pkgStdRiskTxt.pkgStdRiskTxtId.scheme = data.scheme
    state.pkgStdRiskTxt.pkgStdRiskTxtId.riskNo = data.riskNo
    state.pkgStdRiskTxt.pkgStdRiskTxtId.stdRiskTxtRef = data.stdRiskTxtRef
    state.pkgStdRiskTxt.pkgStdRiskTxtId.busCls = data.busCls
    state.pkgStdRiskTxt.pkgStdRiskTxtId.tranMode = data.tranMode
  },
  [PKGSTDITEMTXT_INIT_LOADING](state) {
    state.pkgStdItemTxt.init = 0
    state.pkgStdItemTxt.menu = {}
    state.pkgStdItemTxt.initErr = []
  },
  [PKGSTDITEMTXT_INIT_SUCCESS](state, data) {
    state.pkgStdItemTxt.init = 1
    state.pkgStdItemTxt.menu = data.menu
    state.pkgStdItemTxt.initErr = []
  },
  [PKGSTDITEMTXT_INIT_FAIL](state, err) {
    state.pkgStdItemTxt.init = 2
    state.pkgStdItemTxt.menu = {}
    state.pkgStdItemTxt.initErr = err
  },
  [PKGSTDITEMTXT_COMMIT_KEY](state, data) {
    state.pkgStdItemTxt.pkgStdItemTxtId.scheme = data.scheme
    state.pkgStdItemTxt.pkgStdItemTxtId.riskNo = data.riskNo
    state.pkgStdItemTxt.pkgStdItemTxtId.itemNo = data.itemNo
    state.pkgStdItemTxt.pkgStdItemTxtId.stdRiskTxtRef = data.stdRiskTxtRef
    state.pkgStdItemTxt.pkgStdItemTxtId.stdRiskItemTxt = data.stdRiskItemTxt
    state.pkgStdItemTxt.pkgStdItemTxtId.tranMode = data.tranMode
  },
  [PKGSTDSUBITEMTXT_INIT_LOADING](state) {
    state.pkgStdSubItemTxt.init = 0
    state.pkgStdSubItemTxt.menu = {}
    state.pkgStdSubItemTxt.initErr = []
  },
  [PKGSTDSUBITEMTXT_INIT_SUCCESS](state, data) {
    state.pkgStdSubItemTxt.init = 1
    state.pkgStdSubItemTxt.menu = data.menu
    state.pkgStdSubItemTxt.initErr = []
  },
  [PKGSTDSUBITEMTXT_INIT_FAIL](state, err) {
    state.pkgStdSubItemTxt.init = 2
    state.pkgStdSubItemTxt.menu = {}
    state.pkgStdSubItemTxt.initErr = err
  },
  [PKGSTDSUBITEMTXT_COMMIT_KEY](state, data) {
    state.pkgStdSubItemTxt.pkgStdSubItemTxtId.scheme = data.scheme
    state.pkgStdSubItemTxt.pkgStdSubItemTxtId.riskNo = data.riskNo
    state.pkgStdSubItemTxt.pkgStdSubItemTxtId.itemNo = data.itemNo
    state.pkgStdSubItemTxt.pkgStdSubItemTxtId.subItemNo = data.subItemNo
    state.pkgStdSubItemTxt.pkgStdSubItemTxtId.subItemDesc = data.subItemDesc
    state.pkgStdSubItemTxt.pkgStdSubItemTxtId.tranMode = data.tranMode
  },
  [TARIFFFACT_INIT_LOADING](state) {
    state.tariffFact.init = 0
    state.tariffFact.menu = {}
    state.tariffFact.initErr = []
  },
  [TARIFFFACT_INIT_SUCCESS](state, data) {
    state.tariffFact.init = 1
    state.tariffFact.menu = data.menu
    state.tariffFact.initErr = []
  },
  [TARIFFFACT_INIT_FAIL](state, err) {
    state.tariffFact.init = 2
    state.tariffFact.menu = {}
    state.tariffFact.initErr = err
  },
  [TARIFFFACT_COMMIT_KEY](state, data) {
    state.tariffFact.tariffFactId.scheme = data.scheme
    state.tariffFact.tariffFactId.planNo = data.planNo
    state.tariffFact.tariffFactId.tariff = data.tariff
    state.tariffFact.tariffFactId.busCls = data.busCls
    state.tariffFact.tariffFactId.benefit = data.benefit
    state.tariffFact.tariffFactId.seqNo = data.seqNo
    state.tariffFact.tariffFactId.effDate = data.effDate
    state.tariffFact.tariffFactId.fact1 = data.fact1
    state.tariffFact.tariffFactId.fact2 = data.fact2
    state.tariffFact.tariffFactId.fact3 = data.fact3
    state.tariffFact.tariffFactId.fact4 = data.fact4
    state.tariffFact.tariffFactId.fact5 = data.fact5
    state.tariffFact.tariffFactId.fact6 = data.fact6
    state.tariffFact.tariffFactId.tranMode = data.tranMode
  },
  [TARIFFRATE_INIT_LOADING](state) {
    state.tariffRate.init = 0
    state.tariffRate.menu = {}
    state.tariffRate.initErr = []
  },
  [TARIFFRATE_INIT_SUCCESS](state, data) {
    state.tariffRate.init = 1
    state.tariffRate.menu = data.menu
    state.tariffRate.initErr = []
  },
  [TARIFFRATE_INIT_FAIL](state, err) {
    state.tariffRate.init = 2
    state.tariffRate.menu = {}
    state.tariffRate.initErr = err
  },
  [TARIFFRATE_COMMIT_KEY](state, data) {
    state.tariffRate.tariffRateId.scheme = data.scheme
    state.tariffRate.tariffRateId.planNo = data.planNo
    state.tariffRate.tariffRateId.tariff = data.tariff
    state.tariffRate.tariffRateId.busCls = data.busCls
    state.tariffRate.tariffRateId.benefit = data.benefit
    state.tariffRate.tariffRateId.seqNo = data.seqNo
    state.tariffRate.tariffRateId.effDate = data.effDate
    state.tariffRate.tariffRateId.fact1 = data.fact1
    state.tariffRate.tariffRateId.fact2 = data.fact2
    state.tariffRate.tariffRateId.fact3 = data.fact3
    state.tariffRate.tariffRateId.fact4 = data.fact4
    state.tariffRate.tariffRateId.fact5 = data.fact5
    state.tariffRate.tariffRateId.fact6 = data.fact6
    state.tariffRate.tariffRateId.tranMode = data.tranMode
  },
  [PACKAGERISK_COMMIT_KEY](state, data) {
    state.pkgRisk.pkgRiskId.tranMode = data.tranMode
    state.pkgRisk.pkgRiskId.scheme = data.scheme
    state.pkgRisk.pkgRiskId.planNo = data.planNo
    state.pkgRisk.pkgRiskId.riskNo = data.riskNo
    state.pkgRisk.pkgRiskId.defBusCls = data.defBusCls
    state.pkgRisk.pkgRiskId.defTariff = data.defTariff
    state.pkgRisk.pkgRiskId.defStdRiskTxt = data.defStdRiskTxt
    state.pkgRisk.pkgRiskId.perMaxItemNo = data.perMaxItemNo
    state.pkgRisk.pkgRiskId.perMaxBeneNo = data.perMaxBeneNo
    state.pkgRisk.pkgRiskId.defClse1 = data.defClse1
    state.pkgRisk.pkgRiskId.defClse2 = data.defClse2
    state.pkgRisk.pkgRiskId.defClse3 = data.defClse3
    state.pkgRisk.pkgRiskId.defClse4 = data.defClse4
    state.pkgRisk.pkgRiskId.defClse5 = data.defClse5
    state.pkgRisk.pkgRiskId.allowClmBefCvr = data.allowClmBefCvr
    state.pkgRisk.pkgRiskId.schemeDesc = data.schemeDesc
    state.pkgRisk.pkgRiskId.polTypeDesc = data.polTypeDesc
  },
  [PACKAGERISKITEM_COMMIT_KEY](state, data) {
    state.pkgRiskItem.pkgRiskItemId.tranMode = data.tranMode
    state.pkgRiskItem.pkgRiskItemId.scheme = data.scheme
    state.pkgRiskItem.pkgRiskItemId.planNo = data.planNo
    state.pkgRiskItem.pkgRiskItemId.riskNo = data.riskNo
    state.pkgRiskItem.pkgRiskItemId.itemNo = data.itemNo
    state.pkgRiskItem.pkgRiskItemId.defStdItemTxtRef = data.defStdItemTxtRef
    state.pkgRiskItem.pkgRiskItemId.defUOM = data.defUOM
    state.pkgRiskItem.pkgRiskItemId.uomAmt = data.uomAmt
    state.pkgRiskItem.pkgRiskItemId.uomUN = data.uomUN
    state.pkgRiskItem.pkgRiskItemId.defBenefit = data.defBenefit
    state.pkgRiskItem.pkgRiskItemId.minSI = data.minSI
    state.pkgRiskItem.pkgRiskItemId.maxSI = data.maxSI
    state.pkgRiskItem.pkgRiskItemId.incSI = data.incSI
    state.pkgRiskItem.pkgRiskItemId.protSI = data.protSI
    state.pkgRiskItem.pkgRiskItemId.protPrem = data.protPrem
    state.pkgRiskItem.pkgRiskItemId.permitDel = data.permitDel
    state.pkgRiskItem.pkgRiskItemId.mandOnPlan = data.mandOnPlan
    state.pkgRiskItem.pkgRiskItemId.defClse1 = data.defClse1
    state.pkgRiskItem.pkgRiskItemId.defClse2 = data.defClse2
    state.pkgRiskItem.pkgRiskItemId.defClse3 = data.defClse3
    state.pkgRiskItem.pkgRiskItemId.applyIndex = data.applyIndex
    state.pkgRiskItem.pkgRiskItemId.indexYr = data.indexYr
    state.pkgRiskItem.pkgRiskItemId.indexPct = data.indexPct
    state.pkgRiskItem.pkgRiskItemId.indexOn = data.indexOn
  },
  [PACKAGERISKSUBITEM_COMMIT_KEY](state, data) {
    state.pkgRiskSubItem.pkgRiskSubItemId.tranMode = data.tranMode
    state.pkgRiskSubItem.pkgRiskSubItemId.scheme = data.scheme
    state.pkgRiskSubItem.pkgRiskSubItemId.planNo = data.planNo
    state.pkgRiskSubItem.pkgRiskSubItemId.riskNo = data.riskNo
    state.pkgRiskSubItem.pkgRiskSubItemId.itemNo = data.itemNo
    state.pkgRiskSubItem.pkgRiskSubItemId.subItemNo = data.subItemNo
  },
  [SCHEMECLAUSE_INIT_LOADING](state) {
    state.schemeClause.init = 0
    state.schemeClause.menu = {}
    state.schemeClause.initErr = []
  },
  [SCHEMECLAUSE_INIT_SUCCESS](state, data) {
    state.schemeClause.init = 1
    state.schemeClause.menu = data.menu
    state.schemeClause.initErr = []
  },
  [SCHEMECLAUSE_INIT_FAIL](state, err) {
    state.schemeClause.init = 2
    state.schemeClause.menu = {}
    state.schemeClause.initErr = err
  },
  [SCHEMECLAUSE_COMMIT_KEY](state, data) {
    state.schemeClause.schemeClauseId.scheme = data.scheme
    state.schemeClause.schemeClauseId.riskNo = data.clseNo
  },
  [ARB_COMMIT_KEY](state, data) {
    state.arb.arbId.tranMode = data.tranMode
    state.arb.arbId.scheme = data.scheme
    state.arb.arbId.planNo = data.planNo
    state.arb.arbId.renYr = data.renYr
    state.arb.arbId.effDate = data.effDate
    state.arb.arbId.arbCalcMeth = data.arbCalcMeth
    state.arb.arbId.arbValRate = data.arbValRate
    state.arb.arbId.arbGrsNet = data.arbGrsNet
    state.arb.arbId.totInstal = data.totInstal
    state.arb.arbId.gstApp = data.gstApp
  },
  [IAB_COMMIT_KEY](state, data) {
    state.iab.iabId.tranMode = data.tranMode
    state.iab.iabId.scheme = data.scheme
    state.iab.iabId.planNo = data.planNo
    state.iab.iabId.adultInsd = data.adultInsd
    state.iab.iabId.insdAge = data.insdAge
    state.iab.iabId.expiryDate = data.expiryDate
    state.iab.iabId.nxtPlanNo = data.nxtPlanNo
  }
}

const actions = {
  async packageManagementInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.packageManagement
    commit(PACKAGE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(PACKAGE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PACKAGE_INIT_FAIL, extractMessages(error))
    }
  },
  async schemeInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.schemeInit
    commit(SCHEME_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(SCHEME_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(SCHEME_INIT_FAIL, extractMessages(error))
    }
  },
  async polTypeSchemeInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.polTypeSchemeInit
    commit(POLTYPESCHEME_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(POLTYPESCHEME_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(POLTYPESCHEME_INIT_FAIL, extractMessages(error))
    }
  },
  async tariffBenInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.tariffBenInit
    commit(TARIFFBEN_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TARIFFBEN_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(TARIFFBEN_INIT_FAIL, extractMessages(error))
    }
  },
  async packagePlanInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.packagePlanInit
    commit(PACKAGEPLAN_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(PACKAGEPLAN_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PACKAGEPLAN_INIT_FAIL, extractMessages(error))
    }
  },
  async pkgStdRiskTxtInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.pkgStdRiskTxtInit
    commit(PKGSTDRISKTXT_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(PKGSTDRISKTXT_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PKGSTDRISKTXT_INIT_FAIL, extractMessages(error))
    }
  },
  async pkgStdItemTxtInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.pkgStdItemTxtInit
    commit(PKGSTDITEMTXT_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(PKGSTDITEMTXT_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PKGSTDITEMTXT_INIT_FAIL, extractMessages(error))
    }
  },
  async pkgStdSubItemTxtInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.pkgStdSubItemTxtInit
    commit(PKGSTDSUBITEMTXT_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(PKGSTDSUBITEMTXT_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(PKGSTDSUBITEMTXT_INIT_FAIL, extractMessages(error))
    }
  },
  async tariffFactInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.tariffFactInit
    commit(TARIFFFACT_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TARIFFFACT_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(TARIFFFACT_INIT_FAIL, extractMessages(error))
    }
  },
  async tariffRateInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.tariffRateInit
    commit(TARIFFRATE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(TARIFFRATE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(TARIFFRATE_INIT_FAIL, extractMessages(error))
    }
  },
  async schemeClauseInit({ commit, rootState }) {
    const apiUrl = rootState.pkgParam.menu.schemeClauseInit
    commit(SCHEMECLAUSE_INIT_LOADING)
    try {
      const result = await http.get(apiUrl)
      const menu = extractMenu(result.data._links)
      const commitResult = {
        menu: menu
      }
      commit(SCHEMECLAUSE_INIT_SUCCESS, commitResult)
    } catch (error) {
      commit(SCHEMECLAUSE_INIT_FAIL, extractMessages(error))
    }
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
